<template>
  <transition name="fade">
    <div class="pnlDialogFull" v-show="show" style="animation-duration: 0.2s">
      <div class="pnlDialogGray" @click.self="CloseDialog">
        <div class="pnlDialogHint">
          <img class="imgIcon" :src="imgSrc" />
          <div class="pnlMsgArea">
            <ul>
              <li
                v-for="item of msgs"
                :key="item"
                v-html="item"
                class="msgItems"
              ></li>
            </ul>
          </div>
          <button class="btnConfirm" @click="BtnClick">{{ btnTxt }}</button>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "DialogHint",
  props: {
    show: Boolean,
    msgs: Array,
    btnTxt: String,
    imgSrc: String,
  },
  data() {
    return {};
  },
  methods: {
    CloseDialog() {
      this.$emit("close-dialog");
    },
    BtnClick() {
      this.$emit("btn-click");
    },
  },
};
</script>